/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderMonthAggregateDto } from './OrderMonthAggregateDto';
import {
    OrderMonthAggregateDtoFromJSON,
    OrderMonthAggregateDtoFromJSONTyped,
    OrderMonthAggregateDtoToJSON,
    OrderMonthAggregateDtoToJSONTyped,
} from './OrderMonthAggregateDto';
import type { OrderMinimalDto } from './OrderMinimalDto';
import {
    OrderMinimalDtoFromJSON,
    OrderMinimalDtoFromJSONTyped,
    OrderMinimalDtoToJSON,
    OrderMinimalDtoToJSONTyped,
} from './OrderMinimalDto';

/**
 * 
 * @export
 * @interface CategoryTreeNodeExtendedDto
 */
export interface CategoryTreeNodeExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    code: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryTreeNodeExtendedDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeExtendedDto
     */
    ownOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeExtendedDto
     */
    ownOrderAmount: number;
    /**
     * 
     * @type {Array<OrderMonthAggregateDto>}
     * @memberof CategoryTreeNodeExtendedDto
     */
    ownMonthlyAggregates?: Array<OrderMonthAggregateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeExtendedDto
     */
    totalOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryTreeNodeExtendedDto
     */
    totalOrderAmount: number;
    /**
     * 
     * @type {Array<OrderMonthAggregateDto>}
     * @memberof CategoryTreeNodeExtendedDto
     */
    totalMonthlyAggregates?: Array<OrderMonthAggregateDto> | null;
    /**
     * 
     * @type {Array<CategoryTreeNodeExtendedDto>}
     * @memberof CategoryTreeNodeExtendedDto
     */
    children?: Array<CategoryTreeNodeExtendedDto> | null;
    /**
     * 
     * @type {Array<OrderMinimalDto>}
     * @memberof CategoryTreeNodeExtendedDto
     */
    orders?: Array<OrderMinimalDto> | null;
}

/**
 * Check if a given object implements the CategoryTreeNodeExtendedDto interface.
 */
export function instanceOfCategoryTreeNodeExtendedDto(value: object): value is CategoryTreeNodeExtendedDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownOrderCount' in value) || value['ownOrderCount'] === undefined) return false;
    if (!('ownOrderAmount' in value) || value['ownOrderAmount'] === undefined) return false;
    if (!('totalOrderCount' in value) || value['totalOrderCount'] === undefined) return false;
    if (!('totalOrderAmount' in value) || value['totalOrderAmount'] === undefined) return false;
    return true;
}

export function CategoryTreeNodeExtendedDtoFromJSON(json: any): CategoryTreeNodeExtendedDto {
    return CategoryTreeNodeExtendedDtoFromJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryTreeNodeExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'description': json['description'] == null ? undefined : json['description'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'ownOrderCount': json['ownOrderCount'],
        'ownOrderAmount': json['ownOrderAmount'],
        'ownMonthlyAggregates': json['ownMonthlyAggregates'] == null ? undefined : ((json['ownMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoFromJSON)),
        'totalOrderCount': json['totalOrderCount'],
        'totalOrderAmount': json['totalOrderAmount'],
        'totalMonthlyAggregates': json['totalMonthlyAggregates'] == null ? undefined : ((json['totalMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoFromJSON)),
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(CategoryTreeNodeExtendedDtoFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderMinimalDtoFromJSON)),
    };
}

export function CategoryTreeNodeExtendedDtoToJSON(json: any): CategoryTreeNodeExtendedDto {
    return CategoryTreeNodeExtendedDtoToJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoToJSONTyped(value?: CategoryTreeNodeExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'fullName': value['fullName'],
        'description': value['description'],
        'parentId': value['parentId'],
        'ownOrderCount': value['ownOrderCount'],
        'ownOrderAmount': value['ownOrderAmount'],
        'ownMonthlyAggregates': value['ownMonthlyAggregates'] == null ? undefined : ((value['ownMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoToJSON)),
        'totalOrderCount': value['totalOrderCount'],
        'totalOrderAmount': value['totalOrderAmount'],
        'totalMonthlyAggregates': value['totalMonthlyAggregates'] == null ? undefined : ((value['totalMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoToJSON)),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(CategoryTreeNodeExtendedDtoToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderMinimalDtoToJSON)),
    };
}

